import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CircularLoader } from '@blade/ui-kit'

import { GlassDialog } from '../glass-dialog'
import { CheckCircleIcon, CrossCircleIcon } from '../icons'

import type { GlassDialogProps } from '../glass-dialog'
import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

export type GlassProgressDialogProps = {
  intent: AsyncStateN.AsyncStateN<unknown, unknown>
  title: React.ReactNode
  description?: React.ReactNode
} & ClassNameProps &
  GlassDialogProps &
  ChildrenProps

export const GlassProgressDialog = ({
  title,
  intent,
  description,
  className,
  children,
  ...props
}: GlassProgressDialogProps) => {
  const renderIcon = () => {
    if (AsyncStateN.isSuccess(intent)) {
      return <IconSuccess size={40} color="var(--boostGlow-9)" />
    }
    if (AsyncStateN.isError(intent)) {
      return <IconError size={40} />
    }

    return <CircularLoader size={36} />
  }

  return (
    <Root {...props} className={className} intent={intent}>
      <Content>
        {renderIcon()}
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Footer>{children}</Footer>
      </Content>
    </Root>
  )
}

const Root = styled(GlassDialog)`
  width: 290px;
`

const IconSuccess = styled(CheckCircleIcon)``

const IconError = styled(CrossCircleIcon)`
  color: var(--red-9);
`

const Title = styled.div`
  color: var(--text-12);
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding: 0 52px;

  margin-top: 16px;
`

const Description = styled.div`
  color: var(--text-9);

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: inline-block;
`

const Content = styled.div`
  padding-top: 30px;

  display: grid;
  place-content: center;
  place-items: center;
`

const Footer = styled.footer`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;

  padding-top: 12px;
  height: 48px;
  gap: 4px;
`

const Button = styled.button`
  background: var(--backgroundA-3);
  color: var(--text-11);

  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  border: 0;
  border-radius: 64px;
  height: 24px;
  padding: 0px 12px;
  flex-shrink: 0;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
`

GlassProgressDialog.Button = Button
